import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconNotificationComponent } from "./med-icon-notification.component";

@NgModule({
  declarations: [
    MedIconNotificationComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconNotificationComponent,
  ],
})
export class MedIconNotificationModule { }
